<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon :class="formIconClass">{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="status"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Status</label>
            <md-select
              v-model="status"
              name="status"
              id="status"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(status, index) in statuses"
                :value="index"
                :key="index"
                >{{ status.label }}</md-option
              >
            </md-select>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="year"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Jaar</label>
            <md-select
              v-model="year"
              name="year"
              id="year"
              required
              :disabled="requesting || disabledForEdit"
            >
              <md-option
                v-for="(yearOption, index) in [
                  2022,
                  2023,
                  2024,
                  2025,
                  2026,
                  2027,
                  2028,
                  2029,
                  2030,
                  2031,
                  2032,
                  2033
                ]"
                :value="yearOption"
                :key="index"
                >{{ yearOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="week"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Week</label>
            <md-select
              v-model="week"
              name="week"
              id="week"
              required
              :disabled="requesting || disabledForEdit"
            >
              <md-option
                v-for="(weekOption, index) in [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17,
                  18,
                  19,
                  20,
                  21,
                  22,
                  23,
                  24,
                  25,
                  26,
                  27,
                  28,
                  29,
                  30,
                  31,
                  32,
                  33,
                  34,
                  35,
                  36,
                  37,
                  38,
                  39,
                  40,
                  41,
                  42,
                  43,
                  44,
                  45,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53
                ]"
                :value="weekOption"
                :key="index"
                >{{ weekOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formOrScheduleTouched,
            'md-warning': formOrScheduleTouched
          }"
          :disabled="requesting"
          >Terug</md-button
        >
        <md-button
          :disabled="!formOrScheduleTouched || requesting"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
    <schedule-editor
      v-if="this.$route.params.id !== undefined"
      :schedule-id="this.$route.params.id"
      :data-max-shifts-per-day="maxShiftsPerDay"
      @changed="this.scheduleHasChanged"
      @resetScheduleTouched="this.resetScheduleTouched"
      ref="scheduleEditor"
    ></schedule-editor>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import ScheduleEditor from "./ScheduleEditor.vue";
import swal from "sweetalert2";
export default {
  components: {
    SlideYDownTransition,
    ScheduleEditor
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      status: 1,
      year: "",
      week: "",
      maxShiftsPerDay: 0,
      statuses: [],
      touched: {
        status: false,
        year: false,
        week: false,
        schedule: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.loadScheduleStatuses();
      if (this.$route.params.id !== undefined) {
        this.loadSchedule(this.$route.params.id);
      } else {
        this.loadNext();
      }
    },
    validate() {
      this.requesting = true;
      if (this.scheduleTouched) {
        this.$refs.scheduleEditor.saveSchedule();
      }
      if (!this.formTouched) {
        this.requesting = false;
        return;
      }
      this.$http
        .post(
          this.$apiBaseUrl +
            "schedules/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            status: this.status,
            year: this.year,
            week: this.week
          })
        )
        .then(
          response => {
            this.requesting = false;
            setTimeout(this.resetFormTouched, 100);
            this.notifyVue(
              "Rooster succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            this.requesting = false;
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger");
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan rooster",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formOrScheduleTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadSchedule(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "schedules/" + id).then(
        response => {
          this.status = response.data.schedule.status;
          this.year = response.data.schedule.year;
          this.week = response.data.schedule.week;
          this.maxShiftsPerDay = response.data.schedule.max_shifts_per_day;

          setTimeout(this.resetFormTouched, 100);

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van roosters", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadNext() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "schedules/next").then(
        response => {
          this.year = response.data.scheduleNext.year;
          this.week = response.data.scheduleNext.week;

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van roosters", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadScheduleStatuses() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "schedules/statuses").then(
        response => {
          this.statuses = response.data.scheduleStatuses;
          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van roosters", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    resetFormTouched() {
      this.touched.status = false;
      this.touched.year = false;
      this.touched.week = false;
      this.$refs.scheduleEditor.resetFormTouched();
    },
    resetScheduleTouched() {
      this.touched.schedule = false;
    },
    scheduleHasChanged(val) {
      this.touched.schedule = val;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    status() {
      if (!this.requesting) {
        this.touched.status = true;
      }
    },
    year() {
      if (!this.requesting) {
        this.touched.year = true;
      }
    },
    week() {
      if (!this.requesting) {
        this.touched.week = true;
      }
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Rooster bewerken";
      }
      return "Rooster toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "directions_bus";
      }
      return "directions_bus";
    },
    formIconClass: function() {
      if (this.requesting) {
        return "load-rotate";
      }
      return "directions_bus";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (i !== "schedule" && this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    scheduleTouched: function() {
      for (var i in this.touched) {
        if (i === "schedule" && this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    formOrScheduleTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    disabledForEdit: function() {
      if (this.$route.params.id !== undefined) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
